export const getEmailLoginToken = (): string | null => {
    const emailLoginToken = new URLSearchParams(window.location.search).get('emailLoginToken');

    return emailLoginToken;
};
